<template>
<div class="container" id="apartment">
        <div class="row justify-content-center">
         <div class="col-md-8">
            <div class="card">
              <div>
                <!--<img class="image col-md-6" v-for="(image, i) in images" :src="image" @click="onClick(i)">-->
                <!--<vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>-->
                
                <!--
                <li v-for="image in images" class="project">
                  <img :src="image.img">
                </li>-->
                <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                <img class="image col-md-6" v-for="(image, i) in images" :src="image" @click="onClick(i)">
              </div>
            </div>
         </div>
        </div>
</div>  

</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow'
import myImg from '@/assets/melbourne/melbourne-descr.jpg'
import myImg2 from '@/assets/melbourne/twelve-apostles.jpg'
import myImg3 from '@/assets/melbourne/luna-park.jpg'
import myImg4 from '@/assets/melbourne/tram-city.jpg'
import myImg5 from '@/assets/melbourne/melbourne-beach.jpg'
import myImg6 from '@/assets/melbourne/central-station.jpg'
import myImg7 from '@/assets/melbourne/yarra-river.jpg'
import myImg8 from '@/assets/melbourne/tram.jpg'
import myImg9 from '@/assets/melbourne/tram-new.jpg'
import myImg10 from '@/assets/melbourne/kangaroos.jpg'
import myImg11 from '@/assets/melbourne/state-library.jpg'
import myImg12 from '@/assets/melbourne/melbourne-railway.jpg'
import myImg13 from '@/assets/melbourne/racing.jpg'

export default {
  data () {
    return {
/*
      images: [
      'https://placekitten.com/801/800',
      'https://placekitten.com/802/800',
      'https://placekitten.com/803/800',
      'https://placekitten.com/804/800',
      'https://placekitten.com/805/800',
      'https://placekitten.com/806/800',
      'https://placekitten.com/807/800',
      'https://placekitten.com/808/800',
      'https://placekitten.com/809/800',
      'https://placekitten.com/810/800'
      ],
*/
      images: [
        myImg,
        myImg2,
        myImg3,
        myImg4,
        myImg5,
        myImg6,
        myImg7,
        myImg8,
        myImg9,
        myImg10,
        myImg11,
        myImg12,
        myImg13
      ],
      
      index: 0
    }
  },
  components: {
    VueGallerySlideshow
  }
}
</script>


// WEBPACK FOOTER //
// src/components/apartment.vue